import { type FC } from "react";

import {
  MenuButton as HeadlessUIMenuButton,
  type MenuButtonProps as HeadlessUIMenuButtonPros,
} from "@headlessui/react";

import { style } from "./button_style";
import { type ButtonColor } from "./button_style";

export const MenuButton: FC<
  HeadlessUIMenuButtonPros & {
    color?: ButtonColor;
    full?: boolean;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    className?: string;
  }
> = ({ color, full, size, className, ...props }) => (
  <HeadlessUIMenuButton
    {...props}
    className={style({ color, full, size, className })}
  />
);
